import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, iconButtonLook } from 'components/Buttons/look'

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`

/* O texto não passa por baixo das setas. */
export const Input = styled(BaseInput)`
  ${({ $withArrows }) => $withArrows && 'padding-right: 28px;'}
`

export const ArrowContainer = styled.div`
  position: absolute;
  right: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

/* As duas setas empilhadas cabem nos 36 px da caixa: o tamanho xss da lib, de 16 px. */
export const ArrowButton = styled(LookButton).attrs({ type: 'button' }).attrs(iconButtonLook({ size: 'xss' }))``
